import React from 'react';
import Select, { components } from 'react-select';
import { selectStyle } from './render-select.style';
import { SelectMinor } from '@shopify/polaris-icons';
import { Icon } from '@shopify/polaris';

const CustomDropdownIndicator = ({ isDisabled, ...props }) => {
  const iconColor = isDisabled ? 'subdued' : 'base';

  return (
    <components.DropdownIndicator {...props}>
      <Icon source={SelectMinor} color={iconColor} />
    </components.DropdownIndicator>
  );
};

const SelectCustom = React.forwardRef((props, ref) => {
  return (
    <Select
      ref={ref}
      {...props}
      components={{ DropdownIndicator: CustomDropdownIndicator }}
      styles={selectStyle({})}
    />
  );
});

export default SelectCustom;
